export type TBreakpoints = 'small' | 'medium' | 'large';
export const Breakpoints = {
  small: '(max-width: 700px)',
  medium: '(min-width: 700px)',
  large: '(min-width: 1440px)',
};
